import { ref as t, onMounted as s, onUnmounted as l } from "vue";
function c(r) {
  const n = t(null), o = t(!1);
  let e = null;
  return s(() => {
    e = new IntersectionObserver(
      ([i]) => {
        i.isIntersecting && (o.value = !0, e?.disconnect());
      },
      {
        threshold: 0.1,
        rootMargin: "-40px 0px",
        ...r
      }
    ), n.value && e.observe(n.value);
  }), l(() => {
    e?.disconnect();
  }), { el: n, isVisible: o };
}
export {
  c as useLandingAnimation
};
